import React, { useEffect } from "react";
import clsx from "clsx";
import { useState } from "react";
import styles from "./LoginForm.module.css";
import { useLoginFormValidator } from "./UseLoginFormValidation";
import logo from "../../assets/Gaffer Transparent Logo1.png";
import apple from "../../assets/apple.png";
import { json, Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { ReactComponent as YourIcon2 } from "../../assets/eye-solid.svg";
import { ReactComponent as YourIcon } from "../../assets/eye-slash-solid.svg";
import { ReactComponent as GoogleIcon } from "../../assets/google.svg";
import { useDispatch } from "react-redux";
import { closeModal } from "../../feature/showSlice/showModalSlice";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import {
  firebaseLoginPost,
  firebaseRefreshSubscription,
  loginPost,
  passwordTemp,
  subscriptionActive,
} from "../../api/handleapi";
import { setLoginuserinfo } from "../../feature/showSlice/loginuserinfoSlice";
import { setPaymentdetail } from "../../feature/showSlice/paymentdetailSlice";
import { setUpdateSubscriptionInfo } from "../../feature/showSlice/updateSubscriptionSlice";
import Cookies from "js-cookie";
import Loader from "../../components/loader/Loader";
import {
  emailIncorrecttitle,
  emailnotverified,
  emailnotverifyMsg,
  loginAuthcheck,
  loginAuthsuccesscheck,
} from "../../components/language/Language";
import { auth } from "../../Config/firebase";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { tmppass } from "../../Config/config";
import CompleteProfileForm from "./CompleteProfileForm";

const LoginForm = ({
  openforgot,
  setOpenforgot,
  setShowModalTwo,
  setShowsubscriptionpayment,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [showCompleteProfile, setShowCompleteProfile] = useState(false);
  const [newUserData, setNewUserData] = useState(null);
  const [socialToken, setSocialToken] = useState(null);

  const openModalTwo = () => {
    setShowModalTwo(() => true);
  };

  const currentDate = new Date();

  const navivalue = Cookies.get("navivalue");
  const [form, setForm] = useState({ email: "", password: "" });
  const dispatch = useDispatch();

  const createPost = async () => {
    setLoading(true);
    var bodyFormData = new FormData();
    bodyFormData.append("email", form?.email);
    bodyFormData.append("password", form?.password);

    try {
      const response = await loginPost(bodyFormData);
      let authFirebase = null;

      if (response != null || undefined) {
        authFirebase = await loginOrCreateUser(form?.email, atob(tmppass));

        dispatch(
          setLoginuserinfo({
            userid: response?.data?.data?.id,
            email: response?.data?.data?.email,
            name: response?.data?.data?.name,
            userprofileimage: response?.data?.data?.profileImage,
          }),
        );
      }

      // check the message property conditon for response then update the state
      if (
        response.status === 200 &&
        response?.data?.message === loginAuthcheck
      ) {
        setShowModalTwo(() => false);
        setShowsubscriptionpayment(() => false);
        setLoading(false);

        await swal({
          title: emailnotverified,
          text: "",
          icon: "",
          closeOnClickOutside: false,
          dangerMode: true,
        }).then(() => {
          setForm({
            email: "",
            password: "",
          });
        });
      }
      // check the both status,  message property conditon for response then store the data
      if (
        response.status === 200 &&
        response?.data?.message === loginAuthsuccesscheck
      ) {
        setLoading(false);

        await Cookies.set("token", response?.data?.data?.token);
        await Cookies.set("rrefreshToken", response?.data?.data?.refreshTokens);
        await Cookies.set("email", response?.data?.data?.email);
        await Cookies.set("name", response?.data?.data?.name);
        await Cookies.set("id", response?.data?.data?.id);
        await Cookies.set("username", response?.data?.data?.name);
        await Cookies.set(
          "userprofileimage",
          response?.data?.data?.profileImage,
        );
        await Cookies.set("firebaseuid", authFirebase.uid);

        const getSubscriptionActive = await subscriptionActive(
          authFirebase.uid,
        );

        await firebaseRefreshSubscription(
          authFirebase.uid,
          response?.data?.data?.id,
        );

        setUserEmail(response?.data?.data?.email);
        dispatch(setUpdateSubscriptionInfo(getSubscriptionActive));

        localStorage.setItem(
          "subscriptionInfo",
          JSON.stringify(getSubscriptionActive),
        );

        if (getSubscriptionActive) {
          navigate("/Dashboard");
          setShowModalTwo(false);
          setShowsubscriptionpayment(false);
        } else {
          setShowModalTwo(true);
          setShowsubscriptionpayment(true);
        }
      }
    } catch (error) {
      if (error.response) {
        setLoading(false);
        await swal({
          title: emailIncorrecttitle,
          text: emailnotverifyMsg,
          icon: "error",
          closeOnClickOutside: false,
          dangerMode: true,
        }).then(() => {
          setForm({
            email: "",
            password: "",
          });
        });
      }
    }
  };

  const handleSocialLogin = async (providerName) => {
    setLoading(true);

    let provider;

    if (providerName === "google") {
      provider = new GoogleAuthProvider();
    } else if (providerName === "apple") {
      provider = new OAuthProvider("apple.com");
    }

    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const bodyFormData = new FormData();
      bodyFormData.append("firebaseToken", idToken);

      const response = await firebaseLoginPost(bodyFormData);

      if (response.status === 200 && response.data.success) {
        const userData = response.data.data;

        await Cookies.set("token", userData.token);
        await Cookies.set("rrefreshToken", userData.refreshTokens);
        await Cookies.set("email", userData.email);
        await Cookies.set("name", userData.name);
        await Cookies.set("id", userData.id);
        await Cookies.set("firebaseuid", result.user.uid);

        if (userData.isNewUser) {
          setNewUserData(userData);
          setSocialToken(userData.token);
          setShowCompleteProfile(true);
          setLoading(false);
        } else {
          // Flujo normal de login exitoso
          const getSubscriptionActive = await subscriptionActive(
            result.user.uid,
          );
          await firebaseRefreshSubscription(result.user.uid, userData.id);

          dispatch(setUpdateSubscriptionInfo(getSubscriptionActive));
          localStorage.setItem(
            "subscriptionInfo",
            JSON.stringify(getSubscriptionActive),
          );

          setLoading(false);
          if (getSubscriptionActive) {
            navigate("/Dashboard");
            setShowModalTwo(false);
            setShowsubscriptionpayment(false);
          } else {
            setShowModalTwo(true);
            setShowsubscriptionpayment(true);
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Social login error:", error);
      swal("Error", "Error al iniciar sesión con redes sociales", "error");
    }
  };

  const loginOrCreateUser = async (email, password) => {
    try {
      const authFirebase = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );

      return authFirebase.user;
    } catch (error) {
      console.log("Error al iniciar sesión:", error.code);
      if (
        error.code === "auth/user-not-found" ||
        error.code === "auth/invalid-credential"
      ) {
        const newUser = await createUserWithEmailAndPassword(
          auth,
          email,
          password,
        );
        console.log("Usuario creado:", newUser.user);
        return newUser.user;
      } else {
        console.error("Error al autenticar:", error.message);
        throw error;
      }
    }
  };

  const { errors, validateForm, onBlurField } = useLoginFormValidator(form);
  const onUpdateField = (e) => {
    const field = e.target.name;
    const nextFormState = { ...form, [field]: e.target.value };
    setForm(nextFormState);
    if (errors[field].dirty)
      validateForm({
        form: nextFormState,
        errors,
        field,
      });
  };
  const onSubmitForm = (e) => {
    e.preventDefault();

    const { isValid } = validateForm({ form, errors, forceTouchErrors: true });
    if (!isValid) {
      return;
    }
    createPost();
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  if (showCompleteProfile) {
    return (
      <CompleteProfileForm
        userData={newUserData}
        onComplete={() => {
          setShowModalTwo(false);
          navigate("/Dashboard");
        }}
        onSkip={() => {
          setShowModalTwo(false);
          navigate("/Dashboard");
        }}
      />
    );
  }

  return (
    <form className={styles.form} onSubmit={onSubmitForm}>
      <img className={styles.loginlogo} src={logo} alt="img" />
      <div className={styles.formGroup}>
        <h5 className={styles.wel_head}>
          <b>Welcome Back!</b>
        </h5>
        <label className={styles.formLabel}></label>
        <input
          className={clsx(
            styles.formField,
            errors.email.dirty && errors.email.error && styles.formFieldError,
          )}
          type="text"
          autocomplete="off"
          aria-label="Email field"
          name="email"
          placeholder="Email"
          value={form?.email}
          onChange={onUpdateField}
          onBlur={onBlurField}
        />
        {errors.email.dirty && errors.email.error ? (
          <p className={styles.formFieldErrorMessage}>{errors.email.message}</p>
        ) : null}
      </div>
      <div className="mb-2">
        <div className={styles.formGroup}>
          <label className={styles.formLabel}></label>
          <input
            className={clsx(
              styles.formField,
              errors.password.dirty &&
                errors.password.error &&
                styles.formFieldError,
            )}
            type={showPassword ? "text" : "password"}
            autocomplete="off"
            aria-label="Password field"
            name="password"
            id="myInput"
            placeholder="Password"
            value={form?.password}
            onChange={onUpdateField}
            onBlur={onBlurField}
          />{" "}
          <div onClick={togglePasswordVisibility}>
            {showPassword ? (
              <YourIcon className={styles.icon_password_login} />
            ) : (
              <YourIcon2 className={styles.iicon_password_login} />
            )}
          </div>
          {errors.password.dirty && errors.password.error ? (
            <p className={styles.formFieldErrorMessage}>
              {errors.password.message}
            </p>
          ) : null}
        </div>{" "}
      </div>

      <div className="form-check text-end mb-2">
        <a
          className={styles.password_link}
          onClick={() => setOpenforgot(!openforgot)}
        >
          Forgot Password?
        </a>
      </div>
      <div className={styles.formActions}>
        <button
          className={styles.formSubmitBtn}
          type="submit"
          onClick={onSubmitForm}
        >
          Sign In{" "}
        </button>
      </div>

      <h6 className={styles.loginf_h6}>
        Not registered yet?{" "}
        <a className={styles.a_elem} onClick={openModalTwo}>
          Register
        </a>
      </h6>

      <div className={styles.separator}>
        <span className={styles.separatorText}>Or</span>
      </div>

      <div className={styles.socialButtons}>
        <button
          type="button"
          className={styles.googleBtn}
          onClick={() => handleSocialLogin("google")}
        >
          <GoogleIcon width="20" height="20" />
          Continue with Google
        </button>
        <button
          type="button"
          className={styles.appleBtn}
          onClick={() => handleSocialLogin("apple")}
        >
          <img src={apple} alt="Apple" width="20" />
          Continue with Apple
        </button>
      </div>

      <p className={styles.para_term_policy}>
        {" "}
        By registering, you agree to Gaffer<sup className="Trademark">
          TM
        </sup>{" "}
        <Link to="/Privacypolicy" onClick={() => dispatch(closeModal(false))}>
          <a className={styles.a_ele} href="/Privacypolicy">
            Privacy Policy
          </a>
        </Link>
      </p>
      {loading ? <Loader /> : null}
    </form>
  );
};

export default LoginForm;
